import { render, staticRenderFns } from "./integralOredr.vue?vue&type=template&id=62827f8e&scoped=true&"
import script from "./integralOredr.vue?vue&type=script&lang=js&"
export * from "./integralOredr.vue?vue&type=script&lang=js&"
import style0 from "./integralOredr.vue?vue&type=style&index=0&id=62827f8e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62827f8e",
  null
  
)

export default component.exports